import * as MobX from "mobx";
import { InitialState } from "../Models";
import { runInAction } from "mobx";
import { StoresInstance } from "../Stores";
import { deleteJWT, isJWTValid, ViewModelBase, getJWT } from "@shoothill/core";

export class InitViewModel extends ViewModelBase<any> {
    @MobX.observable
    public DataReady: boolean = false;
    public InitData: InitialState = {} as InitialState;

    constructor() {
        super({});
    }

    public getInitialState = async (): Promise<boolean> => {
        await this.validateAndCleanJWT();
        const apiResult = await this.fetchInitialState();
        await this.ensureValidJWT(apiResult);
        this.initializeStores(apiResult);
        return apiResult.wasSuccessful;
    };

    private validateAndCleanJWT = async (): Promise<void> => {
        const isValid = await isJWTValid();
        if (!isValid) {
            deleteJWT();
        }
    };

    private fetchInitialState = async (): Promise<any> => {
        return await this.Get<InitialState>("/api/initialstate/getinitialstatejson");
    };

    private ensureValidJWT = async (apiResult: any): Promise<void> => {
        const serverJWT = apiResult.payload.accountStatus.jwt;
        const hasServerJWT = serverJWT && serverJWT !== "";

        if (!hasServerJWT) {
            const storedJWT = await this.getStoredValidJWT();
            if (storedJWT) {
                apiResult.payload.accountStatus.jwt = storedJWT;
            }
        }
    };

    private getStoredValidJWT = async (): Promise<string | null> => {
        const isValid = await isJWTValid();
        if (isValid) {
            return await getJWT();
        }
        return null;
    };

    private initializeStores = (apiResult: any): void => {
        runInAction(() => {
            StoresInstance.init(apiResult.payload);
            this.InitData = apiResult.payload;
            this.DataReady = true;
        });
    };

    public async isFieldValid(fieldName: "emailAddress" | "password", value: any): Promise<boolean> {
        return true;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
